// Paths
import { APP_PATH } from '../../../routes/paths';

// components
import SvgIconStyle from '../../../components/SvgIconStyle';

import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
};

const navConfig = [
  {
    subheader: 'Tools',
    admin: false,
    items: [
      {
        title: 'dashboard',
        path: '/dashboard/',
        icon: <Iconify icon="mdi:home" width={20} height={20} />,
        admin: false,
      },
      {
        title: 'instruments',
        path: '/instruments/',
        icon: <Iconify icon="mdi:tools" width={20} height={20} />,
        admin: false,
      },
      {
        title: 'references',
        path: '/references/',
        icon: <Iconify icon="mdi:ruler-square-compass" width={20} height={20} />,
        admin: true,
      },
      {
        title: 'reports',
        path: '/reports/',
        icon: <Iconify icon="mdi:chart-box" width={20} height={20} />,
        admin: false,
      },
    ],
  },
  {
    subheader: 'Management',
    admin: true,
    items: [
      {
        title: 'clients',
        path: '/clients/list',
        icon: ICONS.user,
        admin: true,
      },
      {
        title: 'Database',
        path: '/devices/',
        icon: <Iconify icon="mdi:database" width={20} height={20} />,
        admin: true,
        children: [
          { title: 'devices', path: '/devices/' },
          { title: 'measurement units', path: APP_PATH.database.units },
          // { title: 'custom fields', path: PATH_DASHBOARD.user.list },
        ],
      },
    ],
  },
  {
    subheader: 'Application',
    admin: true,
    items: [
      {
        title: 'users',
        path: '/users/list',
        icon: ICONS.user,
        admin: true,
      },
    ],
  },
];

export default navConfig;
